export default __webpack_public_path__ + "static/media/IMG_5380.e28b2625.JPG";